import React from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";

import { Badge, Collapse } from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";

// import { Box } from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

import routes from "../routes/index";
import avatar from "../assets/img/avatars/avatar.jpg";
// import cabfareLogo from "../assets/img/cabfare/cabfare-logo.svg";
import cabfareLogoWhite from "../assets/img/cabfare/cabfare-logo-white.png";

import { toggleSidebar } from "../redux/actions/sidebarActions";

const ExtSidebarCategory = withRouter(
  ({
    name,
    badgeColor,
    badgeText,
    icon: Icon,
    isOpen,
    children,
    onClick,
    location,
    to
  }) => {
    const getSidebarItemClass = path => {
      return location.pathname.indexOf(path) !== -1 ||
        (location.pathname === "/" && path === "/dashboard")
        ? "active"
        : "";
    };

    return (
      <li className={"sidebar-item " + getSidebarItemClass(to)}>
        <span
          data-toggle="collapse"
          className={"sidebar-link " + (!isOpen ? "collapsed" : "")}
          onClick={onClick}
          aria-expanded={isOpen ? "true" : "false"}
        >
          <Icon size={18} className="align-middle mr-3" />
          <span className="align-middle">{name}</span>
          {badgeColor && badgeText ? (
            <Badge color={badgeColor} size={18} className="sidebar-badge">
              {badgeText}
            </Badge>
          ) : null}
        </span>
        <Collapse isOpen={isOpen}>
          <ul id="item" className={"sidebar-dropdown list-unstyled"}>
            {children}
          </ul>
        </Collapse>
      </li>
    );
  }
);

const ExtSidebarItem = withRouter(
  ({ name, badgeColor, badgeText, tertiary, icon: Icon, location, to, clicker }) => {
    const getSidebarItemClass = path => {
      return location.pathname === path ? "active" : "";
    };
    var tertiaryClass = tertiary ? ' tertiary' : '';
    return (
      <li className={"sidebar-item " + getSidebarItemClass(to) + tertiaryClass}>
        <NavLink to={to} className="sidebar-link" activeClassName="active">
          <span onClick={ () => { !!clicker && clicker(); } }>
            {Icon ? <Icon size={18} className="align-middle mr-3" /> : null}
            {name}
            {badgeColor && badgeText ? (
              <Badge color={badgeColor} size={18} className="sidebar-badge">
                {badgeText}
              </Badge>
            ) : null}
          </span>
        </NavLink>
      </li>
    );
  }
);

class ExtSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  toggle = index => {
    this.setState(state => ({
      [index]: !state[index]
    }));
  };

  toggleSidebar = () => {

    // console.log('isOpen', this.props.sidebar.isOpen);
    // console.log('isSticky', this.props.sidebar.isSticky);

    if (this.props.sidebar.isSticky && !this.props.sidebar.isOpen) {  // this is the mobile situation it seems
      setTimeout(() => {
        // console.log('!!Toggling sidebar!!');
        this.props.toggleSidebar();
      }, 100);
    }

  }

  componentWillMount() {
    /* Open collapse element that matches current url */
    const pathName = this.props.location.pathname;

    routes.forEach((route, index) => {
      const isActive = pathName.indexOf(route.path) === 0;
      const isOpen = route.open;
      const isHome = route.containsHome && pathName === "/";

      this.setState(() => ({
        [index]: isActive || isOpen || isHome
      }));
    });
  }

  render() {
    const { sidebar, layout } = this.props;
    const entity_type = this.props.user.currentUser.entity_type;
    const terminalLabel = this.props.user.currentUser.terminal_label;

    return (
      <nav
        className={
          "sidebar" +
          (!sidebar.isOpen ? " toggled" : "") +
          (sidebar.isSticky ? " sidebar-sticky" : "")
        }
      >
        <div className="sidebar-content">
          <PerfectScrollbar>
            <a className="sidebar-brand" href="/extranet/dashboard">
              {/*<Box className="align-middle text-primary mr-2" size={24} />{" "}*/}
              <img
                src={cabfareLogoWhite}
                alt="Cabfare"
                className="img-fluid"
                // width="300"
                style={{}}
              />
              {/*<span className="align-middle">AppStack</span>*/}
            </a>

            <ul className="sidebar-nav">
              {routes.map((category, index) => {
                return category.hidden ? (<span/>) : (
                  <React.Fragment key={index}>
                    {category.header ? (
                      <li className="sidebar-header">{category.header}</li>
                    ) : null}

                    {category.children ? (
                      <ExtSidebarCategory
                        name={category.name}
                        badgeColor={category.badgeColor}
                        badgeText={category.badgeText}
                        icon={category.icon}
                        to={category.path}
                        isOpen={this.state[index]}
                        onClick={() => this.toggle(index)}
                      >
                        {category.children.map((route, index) => {

                          // console.log('!!!!!!!!!!!!!!!!!!!!!!!!', route, entity_type);
                          if (
                            route.hidden ||
                            ( !!route.roles && !route.roles.includes(entity_type) )
                          ) {
                            return (<span key={index} />);
                          } else {
                            return (
                              <ExtSidebarItem
                                key={index}
                                name={route.name.replace('{{sLabel}}', terminalLabel)}
                                to={route.path}
                                badgeColor={route.badgeColor}
                                badgeText={route.badgeText}
                                tertiary={route.tertiary}
                                clicker={()=>{
                                  setTimeout(()=>this.toggleSidebar(), 500);
                                }}
                              />
                            );
                          } // if/else

                        }) //map
                        }
                      </ExtSidebarCategory>
                    ) : (
                      <ExtSidebarItem
                        name={category.name.replace('{{sLabel}}', terminalLabel)}
                        to={category.path}
                        icon={category.icon}
                        badgeColor={category.badgeColor}
                        badgeText={category.badgeText}
                        // clicker={()=>{console.log('Shitballs')}}
                      />
                    )}
                  </React.Fragment>
                );
              })}
            </ul>

            {!layout.isBoxed && !sidebar.isSticky ? (
              <div className="sidebar-bottom d-none d-lg-block">
                <div className="media">
                  <img
                    className="rounded-circle mr-3"
                    src={avatar}
                    alt="Chris Wood"
                    width="40"
                    height="40"
                  />
                  <div className="media-body">
                    <h5 className="mb-1">Chris Wood</h5>
                    <div>
                      <FontAwesomeIcon
                        icon={faCircle}
                        className="text-success"
                      />{" "}
                      Online
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </PerfectScrollbar>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = store => ({
  sidebar: store.sidebar,
  layout: store.layout,
  user: store.user,
})

const mapDispatchToProps = dispatch => ({ // implicit return
  toggleSidebar: () => dispatch(toggleSidebar())
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ExtSidebar)
);
